import React from 'react';

const SkipLink = () => {
  return (
    <a 
      href="#main-content"
      className="skip-link absolute -top-10 left-4 z-50 bg-white text-black px-4 py-2 rounded-md shadow-lg transition-all duration-200 focus:top-4 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      style={{ 
        clipPath: 'rect(0 0 0 0)',
        position: 'absolute',
        transform: 'translateY(-100%)',
      }}
      onFocus={(e) => {
        e.target.style.clipPath = 'none';
        e.target.style.transform = 'translateY(0)';
      }}
      onBlur={(e) => {
        e.target.style.clipPath = 'rect(0 0 0 0)';
        e.target.style.transform = 'translateY(-100%)';
      }}
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;